import BackButton from "./BackButton";

export function PageHeader({
  title,
  description,
  icon,
  children,
  showBackButton = false,
}: {
  title: string;
  description: React.ReactNode;
  icon: React.ReactNode;
  children?: React.ReactNode;
  showBackButton?: boolean;
}) {
  return (
    <div className="flex items-center justify-between w-full mb-8 dark:text-zinc-400 flex-col md:flex-row gap-4">
      <div className="flex items-center gap-3 w-full">
        {showBackButton && <BackButton />}
        <div className="p-2 bg-indigo-50 dark:bg-indigo-900 rounded-lg text-indigo-600 dark:text-indigo-400">
          {icon}
        </div>
        <div>
          <h1 className="text-xl font-semibold text-gray-900 dark:text-zinc-100">
            {title}
          </h1>
          <p className="text-sm text-gray-500 dark:text-zinc-400 mt-0.5">
            {description}
          </p>
        </div>
      </div>

      {children}
    </div>
  );
}
